// extracted by mini-css-extract-plugin
export default {"threeCols":"fourthSec_threeCols__3AzNl","col":"fourthSec_col__NM1Ba","img":"fourthSec_img__BE2lI","hr":"fourthSec_hr__5xkrE"};